var _path, _path2, _path3, _ellipse, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreciseLocationUnselected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 43,
    viewBox: "0 0 31 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2316 14.6939C29.2316 11.0621 27.7583 7.57897 25.1359 5.01087C22.5135 2.44276 18.9567 1 15.248 1V7.31812C16.2371 7.31811 17.2165 7.50889 18.1303 7.87956C19.0441 8.25023 19.8744 8.79352 20.5738 9.47843C21.2732 10.1633 21.828 10.9764 22.2065 11.8713C22.585 12.7662 22.7798 13.7253 22.7798 14.6939C22.7798 15.6625 22.585 16.6216 22.2065 17.5165C21.828 18.4114 21.2732 19.2245 20.5738 19.9094C19.8744 20.5943 19.0441 21.1376 18.1303 21.5083C17.2165 21.8789 16.2371 22.0698 15.248 22.0698V40.9866C15.248 40.9866 21.8432 30.6905 24.3378 27.171C29.8433 19.4489 29.2316 14.6939 29.2316 14.6939Z",
    fill: "#1D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2534 7.31812V1C11.5447 1 7.98793 2.44276 5.36552 5.01087C2.7431 7.57897 1.26985 11.0621 1.26985 14.6939C1.26985 14.6939 0.639012 19.4489 6.1636 27.171C8.65826 30.653 15.2534 40.9866 15.2534 40.9866V22.0698C13.2558 22.0698 11.3401 21.2926 9.92758 19.9094C8.5151 18.5262 7.72157 16.6501 7.72157 14.6939C7.72157 12.7377 8.5151 10.8617 9.92758 9.47846C11.3401 8.09522 13.2558 7.31812 15.2534 7.31812Z",
    fill: "#1D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2567 14.7143C29.2567 20.2 19.9205 34.5238 15.2524 41C10.7139 34.3968 1.24783 20.4286 1.24805 14.7143C1.24829 8.2269 6.30516 1 15.2524 1C24.1995 1 29.2567 7.85714 29.2567 14.7143Z",
    stroke: "#1D2943",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.251,
    cy: 14.7085,
    rx: 12.4483,
    ry: 12.1905,
    fill: "#1D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5101 15.5581C13.5101 15.5581 13.5708 19.9839 10.1756 20.1796C6.78094 20.3739 4.6582 16.7949 4.6582 16.7949C4.6582 16.7949 13.0859 15.8843 13.5101 15.5581Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.03 11C25.03 11 17.0277 11.3907 13.5109 11C13.5109 11 16.3003 18.6142 11.0254 20.826C11.0254 20.826 14.1782 21.2174 16.9068 20.826C19.6348 20.4353 25.6979 18.9397 25.03 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreciseLocationUnselected);
export default __webpack_public_path__ + "static/media/precise-location-unselected.bea69386d72b4be2c4e68c7ba4b8da79.svg";
export { ForwardRef as ReactComponent };